import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../stores';
import { IAPanel } from '../../panels/Panel';
import { Helper } from '../../../Helper';
import { IAMessageBar } from '../../messageBar/MessageBar';
import { LocalizationService } from '../../../services/LocalizationService';
import { IFontSlots } from '../../../interfaces/IFontSlots';
import * as styles from './TargetPreviewPanel.css';
import { IAButton } from '../../button/Button';
import { IAIcon } from '../../icon/Icon';
import { ITargetingGroup } from '../../../interfaces/ITargetingGroup';
import { IATextField } from '../../textField/TextField';
import { TargetingService } from '../../../services/TargetingService';
import { IUser } from '../../../interfaces/IUser';
import { IAPeopleSearch } from '../../peopleSearch/PeopleSearch';
import { TreeTargetingForGroups } from '../../treeTargetingForGroups';

export interface IProps {
  navigatorStore?: NavigatorStore;
  fontSlots: IFontSlots;
  onClose: (targetedPreviewIds: number[]) => void;
}

export interface IState {
  searchQuery: string;
  searchResult: ITargetingGroup[];
  groupsUserIsPartOf: ITargetingGroup[];
  people: IUser[];
  noGroupsForUser: boolean;
  targetedPreviewIds: number[];
}

@inject('navigatorStore')
@observer
export default class TargetPreviewPanel extends React.Component<IProps, IState> {

  private readonly localizationService = new LocalizationService();

  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      searchResult: [],
      groupsUserIsPartOf: [],
      people: [],
      noGroupsForUser: false,
      targetedPreviewIds: this.props.navigatorStore.targetedPreviewIds?.length > 0 ? JSON.parse(JSON.stringify(this.props.navigatorStore.targetedPreviewIds)) : []
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getSelectedValues(): any[] {
    const selectedValues = [];
    if (this.props.navigatorStore.targetingGroups?.length > 0 && this.state.targetedPreviewIds?.length > 0) {
      this.props.navigatorStore.targetingGroups.forEach((group: any) => {
        this.state.targetedPreviewIds.forEach((id: number) => {
          if (`${group?.id}` === `${id}`) {
            selectedValues.push({
              Label: group.title,
              TermGuid: group.title,
              id: group.id,
              Name: group.title
            });
          }
        })
      })
    }
    return selectedValues;
  }

  public render() {
    let top = 40;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") != undefined && document.getElementById("IA_navigator_vertical_menu") == undefined) {
      top = 88;
    }
    let applicationSettings;
    if (this.state.searchResult?.length > 0) {
      applicationSettings = JSON.parse(JSON.stringify(this.props.navigatorStore.applicationSettings));
      applicationSettings.targetingGroups = this.state.searchResult;
    }
    console.log(applicationSettings?.targetingGroups);
    return (
      <div id="message">
        <IAPanel
          open={this.props.navigatorStore.showTargetPreviewPanelWithTitle != undefined}
          close={() => {
            this.props.navigatorStore.showTargetPreviewPanelWithTitle = undefined;
            this.props.onClose(this.state.targetedPreviewIds);
          }}
          showNavigationBar={false}
          transition="slide"
          width={window.innerWidth < 600 ? window.innerWidth : 600}
          marginTop={top}
          loading={false}
          panelId={`targetPreviewPanel${Helper.getRandomStringKey()}`}
          footer={
            <>
              <IAButton
                label={this.localizationService.strings.Messages_Clear_Filter}
                style={{
                  float: "left",
                  clear: "both",
                  marginTop: 10
                }}
                buttonColor='gray'
                textColor='white'
                arialable="Disable"
                borderRadius={5}
                disbaled={false}
                onClick={() => {
                  this.setState({ searchQuery: "", searchResult: [], people: [], noGroupsForUser: false, targetedPreviewIds: [] });
                  this.props.onClose([]);
                  this.forceUpdate();
                }}
              />
              <IAButton
                label={this.localizationService.strings.Admin_Save}
                style={{
                  float: "left",
                  marginTop: 10,
                  marginLeft: 15
                }}
                buttonColor={this.props.navigatorStore.highlightColor}
                textColor='white'
                arialable="Disable"
                borderRadius={5}
                disbaled={false}
                onClick={() => {
                  this.props.navigatorStore.showTargetPreviewPanelWithTitle = undefined;
                  this.props.onClose(this.state.targetedPreviewIds);
                }}
              />
            </>
          }
        >
          {this.props.navigatorStore.showTargetPreviewPanelWithTitle != undefined &&
            <div style={{
              padding: 40,
              paddingTop: 10,
              boxSizing: "border-box"
            }}>
              <div
                className={styles.IA_title}
                style={{
                  fontFamily: this.props.fontSlots?.heading?.fontFamily
                }}
              >
                {this.props.navigatorStore.showTargetPreviewPanelWithTitle}
              </div>
              <IAIcon
                title="Close"
                size={18}
                color="#777777"
                onClick={() => {
                  this.props.navigatorStore.showTargetPreviewPanelWithTitle = undefined;
                  this.props.onClose(this.state.targetedPreviewIds);
                }}
                style={{
                  cursor: "pointer",
                  marginLeft: 10,
                  position: "absolute",
                  right: 20,
                  top: 20
                }}
              />
              <IAMessageBar
                type="information"
                onDismiss={() => { }}
                icon="Info"
                content={this.localizationService.strings.Navigator_Admin_TargetPreviewMessage}
                showIcon={false}
                showCloseButton={false}
                style={{
                  marginBottom: 15
                }}
              />
              <IAPeopleSearch
                disabed={this.state.searchQuery?.length > 0 || this.state.searchResult?.length > 0}
                token={this.props.navigatorStore.token}
                tenant={this.props.navigatorStore.tenant?.replace(".sharepoint.com", "")}
                environment={this.props.navigatorStore.environment}
                multiSelection={false}
                placeholderText={`Search for user`}
                backgroundColor="#ffffff"
                selectedValues={this.state.people}
                onSelect={(people: IUser[]) => {
                  this.setState({ noGroupsForUser: false, people: [] });
                  if (people != undefined && people.length > 0) {
                    people.forEach((contact: any) => {
                      contact = Helper.syncUserProperties(contact);
                    });
                  } else {
                    this.setState({ targetedPreviewIds: [] });
                  }
                  const groupsUserIsPartOf = [];
                  const targetedPreviewIds = [];
                  if (people?.length > 0) {
                    TargetingService.getGroupsForUser(this.props.navigatorStore.environment, this.props.navigatorStore.tenant?.replace(".sharepoint.com", ""), this.props.navigatorStore.token, people[0].userPrincipalName).then((groups) => {
                      console.log(groups);
                      if (groups?.length > 0) {
                        this.props.navigatorStore.applicationSettings.targetingGroups.forEach((group: ITargetingGroup) => {
                          groups.forEach((groupUserIsPartOf: ITargetingGroup) => {
                            if (groupUserIsPartOf.id === group.id) {
                              groupsUserIsPartOf.push(group);
                              targetedPreviewIds.push(parseInt(group.id));
                              this.setState({ groupsUserIsPartOf, targetedPreviewIds }, () => this.forceUpdate());
                            }
                          });
                        });
                      } else {
                        this.setState({ noGroupsForUser: true, targetedPreviewIds: [] });
                      }
                    });
                  }
                  this.setState({ groupsUserIsPartOf, people, targetedPreviewIds }, () => this.forceUpdate());
                }}
                style={{
                  width: "100%",
                  clear: "both",
                  border: `1px solid #dddddd`,
                  opacity: this.state.searchQuery?.length > 0 || this.state.searchResult?.length > 0 ? 0.5 : 1,
                }}
                hightlightColor={this.props.navigatorStore.highlightColor}
              />
              {this.state.noGroupsForUser &&
                <div
                  style={{
                    marginTop: 10,
                    color: "red"
                  }}
                >
                  {`${this.state.people[0].name} is not part of any group`}
                </div>
              }
              <IATextField
                label={`Search for groups (${this.state.targetedPreviewIds.length} selected)`}
                text={this.state.searchQuery}
                disabled={this.state.people?.length > 0}
                onChange={(searchQuery: string) => {
                  console.log(this.props.navigatorStore.applicationSettings)
                  const searchResult = [];
                  this.props.navigatorStore.applicationSettings?.targetingGroups?.forEach(group => {
                    if (searchQuery !== "" && group.title.toLowerCase().includes(searchQuery.toLowerCase())) {
                      searchResult.push(group);
                    }
                  });
                  this.setState({ searchQuery, searchResult, targetedPreviewIds: [] }, () => this.forceUpdate());
                }}
                borderRadius={5}
                style={{
                  marginBottom: 10
                }}
                labelStyle={{
                  opacity: this.state.people.length > 0 ? 0.5 : 1
                }}
                showClearTextButton
              />
              <TreeTargetingForGroups
                environment={this.props.navigatorStore.environment}
                tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
                application={"navigator"}
                applicationData={this.state.searchResult?.length > 0 ? applicationSettings : this.props.navigatorStore.applicationSettings}
                instance={this.props.navigatorStore.instance}
                selectedGroupIds={this.getSelectedValues().map((itemData) => itemData.id)}
                showTarget
                hideOptions
                disabled={this.state.people?.length > 0}
                highlightColor={this.props.navigatorStore.adminColor}
                onShowTargetChanged={() => { }}
                onGroupIdsUpdated={(ids: number[]) => {
                  this.setState({ targetedPreviewIds: ids });
                  this.props.navigatorStore.getTopItems();
                }}
              />
            </div>
          }
        </IAPanel >
      </div >
    );
  }
}


